module.exports = __webpack_public_path__ + "static/logo-8cb0f90e2c6c272955491bee35ffc178.svg";